import { IComponentOptions, IController, ITimeoutService } from 'angular';
import { IFunctionBinding } from '../../../classes';
import template from './tn-combobox.html';

export interface ITnComboboxOnChangedArgs {
    value: string;
}

/**
 *  IComboBox for string.
 */
export interface ITnComboboxBindings {
    model?: string;
    placeholder?: string;
    options?: string[];
    onChanged?: IFunctionBinding<ITnComboboxOnChangedArgs>;
}

export class ComboboxComponent implements ITnComboboxBindings, IController {
    // Bindings
    public model = '';
    public placeholder = '';
    public options: string[] = [];
    public onChanged?: IFunctionBinding<ITnComboboxOnChangedArgs, void>;

    // Locals
    public isTextInputFocused = false;
    public isTextInputChanged = false;
    public dropdownVisible = false;

    static $inject = ['$timeout'];
    constructor(protected $timeout: ITimeoutService) {}

    public _onTextInputFocused(): void {
        this.dropdownVisible = !this.model;
    }

    public _onTextInputBlurred(): void {
        // We want the dropdown to be hidden any time someone click on something
        // not in the dropdown. The blur event does a good job. With one tiny issue
        // the blur event is triggered when clicking on the drop down, and the ng-show
        // directive gets set to false, which seems to prevent the ng-click directive
        // from being called. to work around this we delay the hide
        this.$timeout(() => this.hideDropdown(), 200);
    }

    public _onTextInputChanged(): void {
        this.dropdownVisible = !this.model;
        this.onChanged && this.onChanged({ value: this.model });
    }

    public clear(): void {
        this.model = '';
        this.dropdownVisible = false;
    }

    public hideDropdown(): void {
        this.dropdownVisible = false;
    }

    public showDropdown(): void {
        this.dropdownVisible = true;
    }

    public select(option: string): void {
        // console.log('select', option);
        this.model = option;
        this.dropdownVisible = false;
    }
}

export const TnComboboxComponentOptions: IComponentOptions = {
    bindings: {
        model: '<',
        placeholder: '@',
        options: '<',
        onChanged: '&',
    },
    controller: ComboboxComponent,
    template,
};
